import { __awaiter, __generator } from "tslib";
import { fetchSFCCSetting } from '../../api';
/**
 * @internal
 */
export var getSFCCProductSearchRequestHeaders = function () { return __awaiter(void 0, void 0, void 0, function () {
    var sfccClientId, requestHeaders;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, fetchSFCCSetting()];
            case 1:
                sfccClientId = (_a = (_b.sent())) === null || _a === void 0 ? void 0 : _a.productSearchApiClientId;
                if (!sfccClientId) {
                    console.warn("SFCC Client ID is not set");
                    return [2 /*return*/, { headers: new Headers(), credentials: 'include' }];
                }
                requestHeaders = new Headers();
                requestHeaders.set("x-dw-client-id" /* ClientId */, sfccClientId);
                return [2 /*return*/, { headers: requestHeaders, credentials: 'include' }];
        }
    });
}); };
